import { Breadcrumb } from "@/composables";
import { LandingPageSetup } from "@/services/landingPages";
import "vue-router";

export enum Layout {
  Default,
  LockingState,
}

declare module "vue-router" {
  interface RouteMeta {
    public?: boolean;
    title?: () => string;
    breadcrumbs?: Breadcrumb[];

    /**
     * Layout to use for this route.
     * Optional - when not set, the default layout will be used.
     */
    layout?: Layout;

    /**
     * Homepage and other category-specific landing pages.
     * Object with appropriate texts/images/...
     */
    landingPageDataFactory?: () => LandingPageSetup;

    /**
     * If a logged-in user visits this route, should they be redirected elsewhere?
     * This is useful when we want to disable access to a public page for logged-in users
     * (e.g., redirect from the public homepage to the dashboard).
     */
    redirectWhenLoggedIn?: RouteLocationAsRelativeGeneric;

    /**
     * Use this option to prevent the page from jumping to the top when URL changes but we're still
     * staying on the same page. Useful when updating URL after some on-page filter is changed -> we
     * don't want to scroll to top whenever the filter is changed.
     */
    preventScrollToTop?: boolean;

    allowNoCountryCode?: boolean;

    /**
     * If set to true, will hide the big, complex footer and show a simple one instead.
     */
    renderSimpleFooter?: boolean;
  }
}
